import CardComponent from "./CardComponent";

export class ButtonViewProfile extends CardComponent {

}
